export default __webpack_public_path__ + "static/Laura.BartonCHAIRMarketing_social-6a2fc0b3558f86fbc6031e2dd28a49c7.jpg";